import { graphql } from '@/graphql-setup'

export const ALL_USER_EXPORTS_QUERY = graphql(`
  query AllUserExports($orderBy: String, $first: Int, $after: String) {
    allUserExports(orderBy: $orderBy, first: $first, after: $after) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          id
          createdAt
          name
          file
          module
          progress
          exception
        }
      }
    }
  }
`)
